import { SET_USER_CASE_CHARGES, REMOVE_USER_CASE_CHARGES } from "../types";

export const setCaseCharges = (userCaseCharges) => ({
  type: SET_USER_CASE_CHARGES,
  userCaseCharges,
});

export const setUserCaseCharges = (userCaseCharges) => (dispatch) => {
  dispatch(setCaseCharges(userCaseCharges));
};

export const removeUserCaseCharges = () => ({
  type: REMOVE_USER_CASE_CHARGES,
});

export const resetUserCaseCharges = () => (dispatch) => {
  dispatch(removeUserCaseCharges());
};



// WEBPACK FOOTER //
// ./src/actions/userCaseCharges.js